module.exports = __webpack_public_path__ + "021ff40f852feb3bf596b575bd82065a.svg";